import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAppKey } from '../../utils/keys';
import { useCachedApp } from '../cache';
export const useApp = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options;
    const { client } = useTribeClient();
    const appKey = getAppKey({ variables, fields });
    const cachedApp = useCachedApp(variables);
    return useQuery(appKey, () => client.app.get(variables, fields), {
        placeholderData: cachedApp,
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useApp.js.map